export const endpoints = {
  DASHBOARD: {
    SUMMARY: '/Dashboard/summary',
    REVENUE_BY_CATEGORY: '/Dashboard/revenue-by-category',
    TOP_PRODUCTS: '/Dashboard/top-products',
    STOCK_WEIGHT_BY_CATEGORY: '/Dashboard/stock-weight-by-category',
  },
  REPORT: {
    SALES_SUMMARY: '/Report/sales-summary',
    SALES_BY_CATEGORY: '/Report/sales-by-category',
    SALES_BY_PRODUCT: '/Report/sales-by-product',
    INVOICE_LIST: '/Report/invoice-list',
  },
  INVOICE: {
    BASE: '/Invoice',
    ITEM: '/InvoiceItemDtl',
  },
};

export default endpoints;
